import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { RevenueRecognitionSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportRevenueRecognition, sortRevenueRecognition } from '../../constants';
import { getRevenueRecognition, getAllRevenueRecognition, onResetDefaultData } from '../../actions';
import { makeGetListRevenueRecognition, makeGetListAllRevenueRecognition } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class RevenueRecognition extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listRevenueRecognition: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listRevenueRecognition: props.listRevenueRecognition,
      totalCount: getPageTotalCount({ ...state, items: props.listRevenueRecognition }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetRevenueRecognitionReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetRevenueRecognitionReport) {
      onResetDefaultData('listRevenueRecognition');
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListRevenueRecognition();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListRevenueRecognition());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListRevenueRecognition());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListRevenueRecognition();
    });
  };

  doGetListRevenueRecognition = () => {
    const { filter, page, size, sorted } = this.state;
    const newFilter = cloneDeep(filter);
    if (newFilter.offsetAccount) newFilter.offsetAccount = newFilter.offsetAccount === 'TRUE' ? 'true' : 'false';
    const { getRevenueRecognition } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) &&
        sortRevenueRecognition[sorted.sortCol] &&
        sortRevenueRecognition[sorted.sortCol][sorted.sortDir]
          ? sortRevenueRecognition[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getRevenueRecognition(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistRevenueRecognition = cb => {
    const { filter, sorted } = this.state;
    const newFilter = cloneDeep(filter);

    if (newFilter.offsetAccount) newFilter.offsetAccount = newFilter.offsetAccount === 'TRUE' ? 'true' : 'false';
    const { getAllRevenueRecognition } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort:
        !isEmpty(sorted) &&
        sortRevenueRecognition[sorted.sortCol] &&
        sortRevenueRecognition[sorted.sortCol][sorted.sortDir]
          ? sortRevenueRecognition[sorted.sortCol][sorted.sortDir]
          : null,
    };
    getAllRevenueRecognition(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistRevenueRecognition(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllRevenueRecognition, t } = this.props;
        convertJson2Pdf({
          data: listAllRevenueRecognition,
          t,
          title: t('reportPage:sidebar.revenueRecognition').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.revenueRecognition')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistRevenueRecognition(() => {
      const { listAllRevenueRecognition, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_REVENUE_RECOGNITION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.revenueRecognition')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.revenueRecognition')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllRevenueRecognition,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { revenueType: 'revenueType', recognitionType: 'revenueRecognitionType' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllRevenueRecognition,
          t,
          title: t('reportPage:sidebar.revenueRecognition').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.revenueRecognition')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.revenueRecognition')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('REVENUE_RECOGNITION_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportRevenueRecognition,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listRevenueRecognition,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllRevenueRecognition,
      t,
      permissions: { modeGetRevenueRecognitionReport, modeDownloadReport, modeGetMailReport },
      isRevenue,
    } = this.props;
    if (!modeGetRevenueRecognitionReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          // linkTo={RouteNames.report.path}
          linkTo={isRevenue ? RouteNames.accountingLog.path : RouteNames.report.path}
          titleBtn="back"
          items={
            isRevenue
              ? [{ name: t('reportPage:sidebar.revenueRecognition') }]
              : [
                  { name: t('label.report'), url: RouteNames.report.path },
                  { name: t('reportPage:sidebar.revenueRecognition') },
                ]
          }
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.revenueRecognition')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <RevenueRecognitionSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div className={isRevenue ? 'mt-5' : ''}>
                <div className="mt-3 d-flex mb-4 pt-3 row">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && !isRevenue && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && !isRevenue && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.revenueRecognition').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllRevenueRecognition,
                          t,
                          title: t('reportPage:sidebar.revenueRecognition').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.revenueRecognition')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && !isRevenue && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listRevenueRecognition}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listRevenueRecognition && listRevenueRecognition.length ? listRevenueRecognition : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

RevenueRecognition.propTypes = {
  getRevenueRecognition: PropTypes.func,
  getAllRevenueRecognition: PropTypes.func,
  listAllRevenueRecognition: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

RevenueRecognition.defaultProps = {
  getRevenueRecognition: () => {},
  getAllRevenueRecognition: () => {},
  listAllRevenueRecognition: [],
};

const mapStateToProps = createStructuredSelector({
  listRevenueRecognition: makeGetListRevenueRecognition() || [],
  listAllRevenueRecognition: makeGetListAllRevenueRecognition() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getRevenueRecognition,
    getAllRevenueRecognition,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(RevenueRecognition)
);
